import {
    createServicesProductItem
} from '@/themes/novaporta/components/reusable/ServicesProduct/types';

const store = {
    namespaced: true,
    state() {
        return {
            services: [],
        }
    },
    getters: {
        getServices: (state) => state.services
    },
    mutations: {
        SET_SERVICES: (state, services) => state.services = services,
    },
    actions: {
        fetchServicesList: async function({ commit }, data) {
            try {
                let services = []
                const { data } = await this.$api.home.getServices()

                if (data && data.length > 0) {
                    services = data[0].service_items.map(item => {
                        return createServicesProductItem({
                            name: item.name,
                            description: item.description,
                            icon: item.icon,
                            link: item.link,
                        })
                    })
                    commit('SET_SERVICES', services)
                }
            } catch (e) {
                console.error(e)
            }
        },
    }
}

export default store